export default __webpack_public_path__ + "static/media/safe4.5f9fefae.png";